// extracted by mini-css-extract-plugin
module.exports = {"center-el":"RecentFeedbackWidget_center-el_3YlP1","widget":"RecentFeedbackWidget_widget_7jxec"};